module.exports = __webpack_public_path__ + "img/feature.b8a97609.jpg";